import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-preview-img-dialog',
  templateUrl: './preview-img.component.html',
  styleUrls: ['./preview-img.component.scss']
})
export class PrivewImgDialogComponent implements OnInit {
  url: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<PrivewImgDialogComponent>) {}

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  ngOnInit() {
    if (this.data) {
      this.url = this.data.url;
    }
  }
}
